import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";
import { useEntitlements } from "../lib/entitlements";
import LockedFeature from "../components/LockedFeature";

export default function DashMenu() {
  const ent = useEntitlements();
  const entitled = ent?.entitled?.orders;
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", price: 0, description: "", category: "Main", prep_minutes: 15 });

  const load = async () => { if (!entitled) return; const r = await api.get("/menu"); setItems(r.data); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [entitled]);

  if (!entitled) return <LockedFeature addonKey="orders" name="To-go Orders & Menu" description="Turn on the Orders add-on to publish a public menu and start taking orders. $8/month, cancel anytime." />;

  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/menu", { ...form, price: parseFloat(form.price), prep_minutes: parseInt(form.prep_minutes || "15") }); setForm({ name: "", price: 0, description: "", category: "Main", prep_minutes: 15 }); load(); toast.success("Added"); }
    catch { toast.error("Failed"); }
  };
  const remove = async (id) => { await api.delete(`/menu/${id}`); load(); };
  const toggleSoldOut = async (i) => {
    try { await api.patch(`/menu/${i.id}`, { sold_out: !i.sold_out }); load(); toast.success(!i.sold_out ? "Marked sold out (86'd)" : "Available again"); }
    catch { toast.error("Failed"); }
  };
  const updatePrep = async (i, prep) => {
    const val = parseInt(prep || "0");
    if (isNaN(val) || val < 0) return;
    try { await api.patch(`/menu/${i.id}`, { prep_minutes: val }); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div>
      <div className="overline">To-go</div>
      <h1 className="text-3xl mb-6">Menu</h1>
      <div className="grid md:grid-cols-3 gap-6">
        <form onSubmit={add} className="paper-card p-6 space-y-3 md:col-span-1">
          <div className="overline">Add item</div>
          <input required placeholder="Name" className="input-field" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="menu-name" />
          <input required type="number" step="0.01" placeholder="Price" className="input-field" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} data-testid="menu-price" />
          <input placeholder="Category" className="input-field" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} />
          <input placeholder="Description" className="input-field" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          <div>
            <label className="overline block mb-1">Prep time (min)</label>
            <input type="number" min={0} className="input-field" value={form.prep_minutes} onChange={(e) => setForm({ ...form, prep_minutes: e.target.value })} data-testid="menu-prep" />
            <p className="text-[11px] text-[#5C6B61] mt-1">Used to set the pickup ETA on guest confirmation SMS.</p>
          </div>
          <button className="btn-primary w-full justify-center" data-testid="menu-add"><Plus size={16} color="#fff" /> Add item</button>
        </form>
        <div className="md:col-span-2 paper-card divide-y divide-[#E1DFD5]">
          {items.length === 0 && <div className="p-10 text-center text-[#5C6B61]">No items yet.</div>}
          {items.map((i) => (
            <div key={i.id} className="p-4 flex items-center justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="font-medium flex items-center gap-2">
                  {i.name}
                  <span className="text-xs text-[#5C6B61]">· {i.category}</span>
                  {i.sold_out && <span className="tag tag-cancelled text-[10px]" data-testid={`menu-soldout-tag-${i.id}`}>SOLD OUT</span>}
                </div>
                <div className="text-xs text-[#5C6B61]">{i.description}</div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-1 text-xs text-[#5C6B61]">
                  <span>Prep</span>
                  <input type="number" min={0} className="input-field !py-1 !px-2 w-16 text-sm" defaultValue={i.prep_minutes ?? 15} onBlur={(e) => updatePrep(i, e.target.value)} data-testid={`menu-prep-${i.id}`} />
                  <span>m</span>
                </div>
                <button onClick={() => toggleSoldOut(i)} className="btn-ghost !py-1.5 !px-3 text-xs" data-testid={`menu-soldout-${i.id}`}>{i.sold_out ? "Restock" : "86 / Sold out"}</button>
                <span className="font-heading font-extrabold">${i.price.toFixed(2)}</span>
                <button onClick={() => remove(i.id)} className="w-9 h-9 rounded-full hover:bg-[#F1D7D2]" data-testid={`menu-del-${i.id}`}><Trash size={16} className="mx-auto" color="#A5382A" /></button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
